import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "q-pa-md q-card",
  style: {"width":"800px","max-width":"80vw"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_field_scheduled_prices = _resolveComponent("form-field-scheduled-prices")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref: "dialogRef",
    onHide: _ctx.onDialogHide
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_q_form, {
          greedy: "",
          onSubmit: _withModifiers(_ctx.onSubmit, ["prevent"]),
          ref: "form"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_form_field_scheduled_prices, {
              modelValue: _ctx.scheduledPricesModel,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.scheduledPricesModel) = $event)),
              "agreement-id": _ctx.id,
              "update-prices": _ctx.updatePricesCallback,
              "create-prices": _ctx.createPricesCallback,
              "delete-prices": _ctx.removePricesCallback,
              "on-submitted": _ctx.onSubmit,
              "on-cancel-click": _ctx.onCancelClick
            }, null, 8, ["modelValue", "agreement-id", "update-prices", "create-prices", "delete-prices", "on-submitted", "on-cancel-click"])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ])
    ]),
    _: 1
  }, 8, ["onHide"]))
}